<template>
  <div class="w-full box p-5" v-if="flagEdit">
    <div class="text-xl text-theme-6">มีการแก้ไขเอกสารที่ต้นทาง</div>
  </div>
  <!-- <div class="w-full box p-5" v-else-if="isDenied">
    <div class="text-xl text-theme-6">ไม่มีสิทธิ์ในเอกสารนี้</div>
  </div> -->
  <div class="w-full box p-5" v-else-if="isShow">
    <div v-if="isClaim" class="flex">
      <div class="text-xl">สถานะ</div>
      <button class="btn btn-warning ml-4" @click="approveClaim">
        Claim
      </button>
    </div>
    <div class="horizontal-form" v-else>
      <div v-if="hasClaim">
        <div class="">
          <label for="" class="form-label sm:w-20">หมายเหตุ</label>
          <textarea
            name=""
            id=""
            rows="5"
            placeholder="เพิ่มเติม..."
            class="form-control"
            :class="{ 'border-theme-6': validateGR.comment.$error }"
            v-model="validateGR.comment.$model"
          ></textarea>
        </div>
        <div class="flex flex-col sm:flex-row mt-4">
          <label for="" class="form-label sm:mt-2 sm:w-28 font-bold"
            >ระบุการตัดสินใจ</label
          >
          <div class="flex flex-col sm:flex-row">
            <div
              class="form-check mr-4"
              v-for="item in optionApprove"
              :key="item.value"
            >
              <input
                type="radio"
                :id="`radio-${item.value}`"
                class="form-radio-input"
                :value="item.value"
                v-model="statusSelected"
              />
              <label :for="`radio-${item.value}`" class="form-check-label">{{
                item.label
              }}</label>
            </div>
          </div>
          <div class="mt-4 ml-0 sm:ml-8 sm:mt-0" v-if="!loading">
            <button
              type="button"
              class="btn btn-primary disabled:opacity-50 mr-2 flex items-center sm:ml-0"
              @click.prevent="approveGR()"
              :disabled="isSubmit"
              v-show="!isHideSubmit"
              v-if="!isHideSubmit"
            >
              <FileTextIcon class="w-4 h-4 mr-2" v-if="!isSubmit" />
              <LoadingIcon
                icon="oval"
                color="white"
                v-else
                class="w-4 h-4 mr-2"
              />
              Save
            </button>
            <button
              v-else
              type="button"
              class="btn box disabled:opacity-50 mr-2 flex items-center sm:ml-0  border-2 border-theme-9 text-theme-9"
            >
              <CheckCircleIcon class="w-4 h-4 mr-2" /> Approve
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="font-bold text-lg text-theme-11">
          เอกสารนี้ถูก Claim โดย {{ approveName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import { requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default defineComponent({
  name: 'approve-gr',
  props: {
    grId: {
      type: Number,
      default: () => {
        return null
      }
    },
    activity: Array,
    employeeId: {
      type: String,
      default: () => {
        return null
      }
    },
    token: {
      type: String,
      default: () => {
        return null
      }
    },
    show: Boolean,
    edit: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    approverInfo: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  emits: ['reload'],
  setup(props, context) {
    const store = useStore()
    const route = useRoute()
    const optionApprove = computed(() => store.state.gr.approveOption)
    const isClaim = computed(() => store.state.gr.isClaim)
    const isHideSubmit = computed(() => store.state.gr.isApprove)
    const comment = ref('')
    const statusSelected = ref('approve')
    const loading = ref(true)
    const isSubmit = ref(false)
    const flagEdit = computed(() => props.edit)
    const isShow = computed(() => props.show)
    const hasClaim = ref(true)
    const approveName = computed(() =>
      !isClaim.value ? props.activity[0].employee_name : ''
    )

    const rulesGR = {
      comment: {
        required: requiredIf(() => statusSelected.value !== 'approve')
      }
    }

    const validateGR = useVuelidate(rulesGR, { comment })

    const approveGR = async () => {
      isSubmit.value = true
      validateGR.value.$touch()
      if (validateGR.value.$invalid) {
        isSubmit.value = false
        return false
      }
      validateGR.value.$reset()
      const dataApprove = {
        gr_id: props.grId,
        approve_result: statusSelected.value,
        approve_reason: comment.value,
        approve_token: null
      }
      if (route.query.token) {
        dataApprove.approve_token = route.query.token
      }
      await store.dispatch('gr/approveGR', dataApprove).then(result => {
        if (result) {
          isSubmit.value = false
          comment.value = ''
          context.emit('reload', true)
        }
      })
      isSubmit.value = false
    }

    const approveClaim = async () => {
      const data = {
        gr_id: props.grId,
        approve_token: null
      }
      if (props.token) {
        data.approve_token = props.token
      }
      const claimEmployeeID = await store.dispatch('gr/approveClaim', data)
      if (claimEmployeeID !== undefined && claimEmployeeID != false) {
        hasClaim.value = true
        await store.dispatch('gr/loadApproveOption', {
          employeeID: claimEmployeeID,
          docID: props.grId
        })
      }
    }

    const checkHasClaim = () => {
      if (props.approverInfo) {
        hasClaim.value = props.approverInfo.employee_id == props.employeeId
      }
    }
    onMounted(() => {
      checkHasClaim()
      loading.value = false
      if (props.employeeId) {
        store.dispatch('gr/loadApproveOption', {
          employeeID: props.employeeId,
          docID: props.grId
        })
      }
    })

    return {
      comment,
      statusSelected,
      optionApprove,
      approveGR,
      isHideSubmit,
      isSubmit,
      isClaim,
      approveClaim,
      loading,
      isShow,
      flagEdit,
      approveName,
      hasClaim,
      validateGR
      // isDenied
    }
  }
})
</script>

<style scoped></style>
